import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getBalanceAndPin } from "../../features/balance-and-pin/balanceAndPinSlice";
import Spinner from "../../components/Spinner";

import {
  MainContainer,
  HeaderSection,
  WelcomeSection,
  BottomImageSection,
  FooterSection
} from "./styles";

import topLogo from "./images/logo.png";
import bottomBackground from "./images/lidl-botttom-bg.png";
import poweredByLogo from "../planica26/imgs/digiseq-logo.svg";

const Uefa26Lidl = () => {
  const [searchParams] = useSearchParams();
  const serialNumber = searchParams.get("serialNumber");

  const dispatch = useDispatch();
  const { balanceAndPin, isLoading } = useSelector(
    (state) => state.balanceAndPin
  );
  const availableBalance = balanceAndPin?.balanceDetails?.availableBalance;
  const numericBalance = Number.parseFloat(availableBalance ?? "");
  const formattedBalance = Number.isFinite(numericBalance)
    ? `€${numericBalance.toFixed(2)}`
    : "€0.00";

  useEffect(() => {
    if (!balanceAndPin && serialNumber) {
      dispatch(
        getBalanceAndPin({
          serial: serialNumber,
          query: "?provider=pannovate"
        })
      );
    }
  }, [balanceAndPin, serialNumber, dispatch]);

  if (isLoading) return <Spinner />;

  return (
    <MainContainer>
      <HeaderSection>
        <img src={topLogo} alt="Lidl UEFA Conference League Final 2026" />
        <p>{"Official Partner"}</p>
        <h1>
          {"Balance"}
          <span>{formattedBalance}</span>
        </h1>
      </HeaderSection>

      <WelcomeSection>
        <h2>{"Welcome to Leipzig!"}</h2>
        <p>
          {
            "We at Lidl HR are delighted to welcome our Lidl colleagues from around the world to join us for the UEFA Conference League Final."
          }
        </p>
        <p>
          {
            "Leipzig is a vibrant cultural hub, located in the heart of Germany. Renowned for its music, creativity and modern urban energy, it is a compact, walkable city."
          }
        </p>
        <p>
          {
            "To enhance your experience at the UEFA Conference League Final, we have provided you with a key fob preloaded with €50 to use during your time at the stadium."
          }
        </p>
        <p>
          {
            "Simply tap it on any contactless payment terminal, just as you would with a debit card, at any outlet that accepts Mastercard."
          }
        </p>
        <p>
          {
            "You can check your balance at the top of this page. Just refresh after making a purchase to see the latest amount. Funds are available until 23:59 on 27 May."
          }
        </p>
        <p>
          {
            "If you have any questions, please visit the Lidl Welcome Desk at the Penta Hotel. We're here to help. Enjoy the Final!"
          }
        </p>
      </WelcomeSection>

      <BottomImageSection>
        <img src={bottomBackground} alt="UEFA and Lidl themed background" />
      </BottomImageSection>

      <FooterSection>
        <p>{"Powered by"}</p>
        <img src={poweredByLogo} alt="Powered by Digiseq" />
        <a href="https://www.digiseq.co.uk/privacy-policy">{"Privacy Policy"}</a>
        <a href="https://digiseq.co.uk/terms-conditions/">
          {"Terms and Conditions"}
        </a>
      </FooterSection>
    </MainContainer>
  );
};

export default Uefa26Lidl;
